import React from "react";
import { Box, IconButton } from "@mui/material";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { PRETTY_BLUE } from "../trips/form/BorderWithLabel";

type AlertFooterControlsProps = {
    alertsCount: number,
    currentIndex: number,
    onPrev: () => void,
    onNext: () => void,
};

export const AlertFooterControls: React.FC<AlertFooterControlsProps> = ( {
    alertsCount,
    currentIndex,
    onPrev,
    onNext
} ) => (
    <Box mt = {2} display = "flex" justifyContent = "space-between" alignItems = "center">
        <IconButton
            size = "small"
            onClick = {onPrev}
            sx = {{ color: PRETTY_BLUE }}
            aria-label = "Previous alert"
        >
            <ArrowBackIosIcon fontSize = "small"/>
        </IconButton>

        <Box display = "flex" justifyContent = "center" mt = {1}>
            {Array.from( { length: alertsCount } ).map( ( _, i ) => (
                <Box
                    key = {i}
                    sx = {{
                        width: 6,
                        height: 6,
                        borderRadius: "50%",
                        backgroundColor: i === currentIndex ? PRETTY_BLUE : "#ccc",
                        mx: 0.3,
                        transition: "background-color 0.3s"
                    }}
                />
            ) )}
        </Box>

        <IconButton
            size = "small"
            onClick = {onNext}
            sx = {{ color: PRETTY_BLUE }}
            aria-label = "Next alert"
        >
            <ArrowForwardIosIcon fontSize = "small"/>
        </IconButton>
    </Box>
);
